/** Gate pass line fields — same layout pattern as PO `itemDetailsFields`; `name` stays API field keys for payloads. */

export const gatePassItemFields = [
  {
    name: "gate_pass_id",
    label: "Gate Pass ID",
    readOnly: true,
    disabled: true,
    placeholder: "Assigned on save",
  },
  {
    name: "sku_code",
    label: "SKU Code",
    placeholder: "",
    hasSearch: true,
    required: true,
  },
  {
    name: "item_name",
    label: "Item Name",
    placeholder: "",
    required: true,
    readOnly: true,
  },
  {
    name: "quantity",
    label: "Quantity",
    type: "number",
    placeholder: "0",
    required: true,
  },
  {
    name: "uom",
    label: "UOM",
    type: "select",
    options: [
      { value: "EA", label: "EA" },
      { value: "PCS", label: "PCS" },
      { value: "KG", label: "KG" },
      { value: "LBS", label: "LBS" },
      { value: "M", label: "M" },
      { value: "FT", label: "FT" },
    ],
    placeholder: "EA",
  },
  { name: "batch_no", label: "Batch No", placeholder: "" },
  { name: "serial_no", label: "Serial No", placeholder: "" },
  {
    name: "item_condition",
    label: "Item Condition",
    type: "select",
    options: [
      { value: "", label: "Select" },
      { value: "Good", label: "Good" },
      { value: "Fair", label: "Fair" },
      { value: "Damaged", label: "Damaged" },
      { value: "New", label: "New" },
      { value: "Used", label: "Used" },
    ],
  },
  { name: "asset_tag", label: "Asset Tag", placeholder: "" },
  { name: "remarks", label: "Remarks", type: "textarea", placeholder: "" },
];
